import { render } from "./PassingEditForm.vue?vue&type=template&id=236d6441&scoped=true"
import script from "./PassingEditForm.vue?vue&type=script&lang=js"
export * from "./PassingEditForm.vue?vue&type=script&lang=js"

import "./PassingEditForm.vue?vue&type=style&index=0&id=236d6441&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236d6441"]])

export default __exports__